var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
    _c(
      "div",
      [
        _vm.loading
          ? _c("b-spinner", { attrs: { small: "", variant: "primary" } })
          : _vm._e()
      ],
      1
    ),
    !_vm.loading
      ? _c("div", [
          _vm.groups.length == 0
            ? _c("div", [
                _c("span", { staticClass: "lead collapse-title ml-5" }, [
                  _vm._v(" Usuario no cuenta con información ")
                ])
              ])
            : _vm._e(),
          _vm.groups.length > 0
            ? _c(
                "div",
                [
                  _c("b-table", {
                    attrs: {
                      hover: "",
                      responsive: "",
                      fields: _vm.groupTableFields,
                      items: _vm.groups,
                      "thead-tr-class": "d-none"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(esLider)",
                          fn: function(row) {
                            return [
                              _c(
                                "div",
                                { staticClass: "row justify-content-end" },
                                [
                                  row.item.esLider === "Y"
                                    ? _c(
                                        "vs-chip",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Lider",
                                              expression: "'Lider'"
                                            }
                                          ],
                                          attrs: {
                                            color: "success",
                                            transparent: ""
                                          }
                                        },
                                        [_vm._v(" lider ")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3324845933
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }